import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { areas } from '../../constants/areas';
import { withAreaSetter } from 'providers/AreasConsumers';
import NotificationContainer from '../notifications/NotificationContainer';
import FlexBox from 'components/common/FlexBox';

const HeaderLinks = ({ setElemByAreaKey }) => {
  const headerLinksRef = useCallback(
    elem => {
      if (elem) setElemByAreaKey(areas.headerLinks, elem);
    },
    [setElemByAreaKey]
  );

  return (
    <FlexBox justifyContent='flex-end' wrap='nowrap' gap={0.5}>
      <div ref={headerLinksRef}></div>
      <NotificationContainer />
    </FlexBox>
  );
};

HeaderLinks.propTypes = {
  setElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaSetter(HeaderLinks);
